export default "__VITE_ASSET__Co6Y8_MW__"